module.exports = __webpack_public_path__ + "static/media/tanja@3x.af04560b.png";